import { observer } from "mobx-react";
import ConditionBuilderStore from "../../../../../../stores/condition-builder-store";
import { DROPDOWN_MENU_WIDTH, SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import FontBody1 from "../../../../../../../../components/fonts/font-body1/font-body1";
import { CONDITION_GROUP_OPERATOR } from "../../../../../../policy-types";


interface IConditionFieldSelectorProps {
    conditionIndex: number;
    condition: ConditionBuilderStore;
}

const ConditionFieldSelector: React.FC<IConditionFieldSelectorProps> = observer(({conditionIndex, condition}) => {
    const conditionGroup = condition.conditionGroupStore;
    const conditionOperatorList = condition.getConditionOperatorList();
    const conditionFieldList = condition.getConditionFieldList();

    const selectedConditionsOperator = conditionOperatorList.find(o => o.value === condition.conditionGroupStore.conditionsOperator);
    const selectedConditionsField = conditionFieldList.find(p => p.value === condition.field);

    const getGroupOperator = () => {
        switch (conditionIndex) {
            case 0:
                return <></>;
            case 1:
                return <SelectDropdown 
                            disabled={!condition.isEditMode}
                            options={conditionOperatorList} 
                            value={selectedConditionsOperator} 
                            onChange={e => conditionGroup.setConditionsOperator(e?.value as CONDITION_GROUP_OPERATOR)}
                            isSearchable={false} />;
            default:
                return <FontBody1>{selectedConditionsOperator?.label}</FontBody1>;
        }
    }
    
    return (
        <>
            { getGroupOperator() }
            <FontBody1>{conditionGroup.conditionsTitle}</FontBody1>
            <SelectDropdown
                    disabled={!condition.isEditMode}
                    value={selectedConditionsField}
                    options={conditionFieldList}
                    onChange={e => condition.setField(e?.value as string)}
                    menuWidth={DROPDOWN_MENU_WIDTH.MAX_CONTENT}
                    isSearchable={false}
                />
        </>
    );

    
});

export default ConditionFieldSelector;